import { lazy } from 'react';

export default {
    Authentication: lazy(() => import('./Authentication')),
    Payin: lazy(() => import('./Payin')),
    PayinOrder: lazy(() => import('./PayinOrder')),
    Payout: lazy(() => import('./Payout')),
    PayoutOrder: lazy(() => import('./PayoutOrder')),
    Settings: lazy(() => import('./Settings')),
    Recover: lazy(() => import('./Recover')),
    PrivacyPolicy: lazy(() => import('./PrivacyPolicy')),
    Tickets: lazy(() => import('./Tickets')),
    Traders: lazy(() => import('./Traders')),
    PayoutTrader: lazy(() => import('./PayoutTrader')),
    Cascades: lazy(() => import('./Cascades')),
    PayoutCascade: lazy(() => import('./PayoutCascade')),
    PayoutCascadeGroup: lazy(() => import('./PayoutCascadeGroup')),
    PayoutCascadeTemplate: lazy(() => import('./PayoutCascadeTemplate')),
};
